import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { getAllRouteData } from 'src/app/lib/get-all-route-data';
import { AssetService } from 'src/app/services/asset.service';

@Injectable({
  providedIn: 'root',
})
export class AssetResolve {
  constructor(private assetService: AssetService) {}

  async resolve(route: ActivatedRouteSnapshot) {
    const data = getAllRouteData(route);
    if (!data.gallery) return;
    const assetId = route.params.assetId.replace('}', '');
    return this.assetService.getAsset(assetId, data.gallery.id);
  }
}
